import { gql, useMutation } from '@apollo/client'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import normalizeLocaleName, {
  SUPPORTED_LANGUAGES,
} from '@src/lib/normalizeLocaleName'
import { userSelector } from '@src/stores/app/selectors'

const LanguageSelector: React.FC<React.PropsWithChildren> = () => {
  const [updateUser] = useMutation(UPDATE_USER)
  const user = useSelector(userSelector)
  const [isUpdating, setIsUpdating] = useState(false)
  return (
    <>
      <Typography variant="overline" color="textSecondary">
        {I18n.t('languageSelector.language')}
      </Typography>
      <select
        style={{ width: '100%' }}
        disabled={isUpdating}
        onChange={async (event) => {
          setIsUpdating(true)

          await updateUser({
            variables: {
              user: {
                id: user.id,
                language_preference: event.target.value,
              },
            },
          })

          window.location.reload()
        }}
        value={normalizeLocaleName(I18n.locale)}
      >
        {SUPPORTED_LANGUAGES.map((x: string) => (
          <option value={x} key={x}>
            {I18n.t(`languageSelector.languages.${x}`)}
          </option>
        ))}
      </select>
    </>
  )
}

const UPDATE_USER = gql`
  mutation updateUserAccountDropdown($user: UpdateUserInput!) {
    updateUser(user: $user) {
      user {
        id
      }
    }
  }
`

export default LanguageSelector
